import { CatalogBrowser } from '../components/CatalogBrowser';
import { movieLink } from '../lib/links';

export function Movies() {
  return <CatalogBrowser kind="movie" title="Movies" hrefFor={(accountId, stream) => movieLink(accountId, stream.id)} />;
}
